import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicFormComponent } from 'app/_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { Globals } from 'app/_globals';
import { SiteListItem } from 'app/_models/site-list-item.model';
import { NotificationService } from 'app/_services/notification.service';
import { SiteService } from 'app/_services/site.service';
import { environment } from 'environments/environment';
import { SortEvent } from 'primeng/api';

@Component({
  selector: 'app-sites',
  templateUrl: './sites.component.html',
})
export class SitesComponent implements OnInit {
  sites: SiteListItem[];
  selectedSite: SiteListItem;

  role: any;
  routeRole: any;

  // pagination
  pageSizes: any = environment.pageSizes;
  pagination: any;
  @ViewChild('paginator', { static: true }) paginator;

  // Filtering
  filters: { [key: string]: string } = {};
  filterName: string = '';
  filterOwner: string = '';
  public isFilterLoading: boolean;

  // Sorting
  public defaultSortField = 'name';
  public defaultSortOrder = 1;
  private sortOrderToText = (sortOrder: number) => {
    return sortOrder === 1 ? 'asc' : 'desc';
  };
  public selectedSort = [this.defaultSortField + ',' + this.sortOrderToText(this.defaultSortOrder)];

  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  constructor(
    public siteService: SiteService,
    public router: Router,
    public globals: Globals,
    public notificationService: NotificationService
    ) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.resetPagination();
  }

  // Get all sites
  public getAllSites() {
    this.siteService.getAllSites(this.pagination, this.selectedSort, this.filters).subscribe(
      (data: any) => {
        this.isFilterLoading = false;
        this.sites = data.body;
        this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error retrieving site list');
        this.isFilterLoading = false;
      }
    );
  }

  // Select Site
  public onRowSelect(event) {
    this.router.navigate(['/' + this.routeRole + '/sites/', event.data.id, 'work-orders']);
  }

  // Handle Pagination
  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllSites();
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };
    this.goToFirstPage();

    this.getAllSites();
  }

  // Handle Sorting and Filtering
  public filterFormSubmitted(value) {
    this.filters = value;
    this.resetPagination();
  }

  public customSort(sort: SortEvent) {
    const sortDirection = this.sortOrderToText(sort.order);

    this.selectedSort = [sort.field + ',' + sortDirection];

    if (sort.field === 'siteOwner') {
      this.selectedSort = [
        'siteOwnerUser.skylarkUser.user.firstName,' + sortDirection,
        'siteOwnerUser.skylarkUser.user.lastName,' + sortDirection,
        'name,' + sortDirection,
      ];
    }

    this.goToFirstPage();

    this.getAllSites();
  }

  public onFilterTextChangedSite(text: string, type: string) {

    if (type === 'filterName') {
      this.filterName = text;
    }
    const filterName = this.filterName || '';

    this.isFilterLoading = true;

    this.filters = {
      name: filterName,
    };

    this.goToFirstPage();
    this.getAllSites();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
